import { FunctionComponent, ReactNode } from "react";

import { type PaywallConfig } from "@context/context/config-context";
import PaywallContext from "@context/context/paywall-context";

interface PaywallProviderProps {
  isPaywallEligible: boolean;
  paywallConfig: PaywallConfig;
  trackingScript?: ReactNode;
  children: ReactNode;
}

const PaywallProvider: FunctionComponent<PaywallProviderProps> = ({
  isPaywallEligible,
  paywallConfig,
  trackingScript,
  children,
}) => {
  return (
    <PaywallContext.Provider value={{ isPaywallEligible, paywallConfig }}>
      {paywallConfig.subXTrackingEnabled && trackingScript}
      {children}
    </PaywallContext.Provider>
  );
};

export default PaywallProvider;
